import { Component } from '@inter-ikea-core/core';

/**
 * Holds the meta data of a light source.
 */
export default class LightSourceMetaComponent implements Component {
  static id = 2067;
  typeId = LightSourceMetaComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;
  lightSourceWidth: number | undefined;
  lightSourceType: string | undefined;
  lightAngle: number | undefined;
  lightIntensity: number | undefined;

  constructor(
    lightSourceWidth: number | undefined,
    lightSourceType: string | undefined,
    lightAngle: number | undefined,
    lightIntensity: number | undefined
  ) {
    this.lightSourceWidth = lightSourceWidth;
    this.lightSourceType = lightSourceType;
    this.lightAngle = lightAngle;
    this.lightIntensity = lightIntensity;
  }

  eq(other: LightSourceMetaComponent) {
    return (
      this.lightSourceWidth === other.lightSourceWidth &&
      this.lightSourceType === other.lightSourceType &&
      this.lightAngle === other.lightAngle &&
      this.lightIntensity === other.lightIntensity
    );
  }
}
